import Layers from "slotworks/graphics/layers/layers";
import gameState from "slotworks/model/game-state";

export function HideBaseLayers() {
    Layers.MatrixBackground.hide();
    Layers.MatrixContent.hide();
    Layers.MatrixForeground.hide();
    Layers.SymbolAnimations.hide();
    Layers.SmartButton.hide();
    Layers.BetBar.hide();
    Layers.Banners.hide();
    Layers.Footer.hide();
    Layers.Custom.get("BonusBuyButton").hide();
    Layers.Custom.get("Messages").hide();
    Layers.Custom.get("MatrixNeon").hide();
    Layers.Custom.get("MatrixAnim").hide();
}

export function ShowBaseLayers() {
    Layers.MatrixBackground.show();
    Layers.MatrixContent.show();
    Layers.MatrixForeground.show();
    Layers.SymbolAnimations.show();
    Layers.Banners.show();
    Layers.Footer.show();
    Layers.Custom.get("BonusBuyButton").show();
    Layers.Custom.get("Messages").show();
    Layers.Custom.get("MatrixNeon").show();
    Layers.Custom.get("MatrixAnim").show();
}

export function ShowBaseLayersFull() {
    Layers.MatrixBackground.show();
    Layers.MatrixContent.show();
    Layers.MatrixForeground.show();
    Layers.SymbolAnimations.show();
    Layers.Banners.show();
    Layers.Footer.show();
    Layers.Custom.get("BonusBuyButton").show();
    Layers.Custom.get("Messages").show();
    Layers.Custom.get("MatrixNeon").show();
    Layers.Custom.get("MatrixAnim").show();
    Layers.SmartButton.show();
    Layers.BetBar.show();
}

export function ShowFSLayersFull() {
    Layers.MatrixBackground.show();
    Layers.MatrixContent.show();
    Layers.MatrixForeground.show();
    Layers.SymbolAnimations.show();
    Layers.Banners.show();
    Layers.Footer.show();
    Layers.Custom.get("Messages").show();
    Layers.Custom.get("MatrixNeon").show();
    Layers.Custom.get("MatrixAnim").show();
    Layers.SmartButton.show();
    Layers.BetBar.show();
}